import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs/index';
import { OrganizationService } from '../../services/organization.service';
import { Organization } from '../../types/organization';
import { LoginService } from '../../services/login.service';
import { LogService } from '../../services/log.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-organization-typeahead',
  template: `
    <ng-template #rt let-r="result" let-t="term">
      {{ r.display }}
    </ng-template>
    <input id="organization"
           name="organization"
           type="text"
           class="form-control"
           placeholder="Start typing to select an organization"
           [(ngModel)]="model"
           [ngbTypeahead]="search"
           [resultTemplate]="rt"
           [inputFormatter]="formatter"
           [class.is-invalid]="searchFailed"
           [editable]="false"
           [showHint]="true"
           (selectItem)="selectedItem($event)"
           required/>
  `
})
export class OrganizationTypeaheadComponent implements OnInit {
  @Input()
  model: Organization;

  @Output()
  searchFailed = false;
  selected: EventEmitter<Organization> = new EventEmitter<Organization>();

  constructor(
    private log: LogService,
    private orgService: OrganizationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {}

  selectedItem(event) {
    this.log.trace('organization selected', event.item);
    this.selected.emit(event.item);
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(
        term =>
          term === ''
            ? []
            : this.orgService
                .getOrganizations()
                .filter(
                  v =>
                    v.OrganizationName.toLowerCase().indexOf(
                      term.toLowerCase()
                    ) > -1
                )
                .slice(0, 10)
      )
    );

  formatter = (x: { OrganizationName: string }) => x.OrganizationName;
}
